<div class="w-100 d-flex flex-column" [ngStyle]="{'min-height': showSearch ? '3rem' : null}">
    <div class="map" *ngIf="!noAddress">
        <agm-map [latitude]="address.lat" [disableDefaultUI]="true" [mapTypeId]="'terrain'" [longitude]="address.long" [zoom]="13" style="height:160px;" (zoomChange)="test($event)" [styles]="mapStyle">
            <agm-marker [latitude]="address.lat" [longitude]="address.long"></agm-marker>
        </agm-map>
    </div>
</div>
